module.exports = __webpack_public_path__ + "static/media/19.20b35976.jpg";